'use strict';

let theme = {

    init: function () {
        this.scrollCue();
        this.swiperSlider();
        this.smoothScrollToTop();
        this.menu();
    },

    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },

    menu: () => {
        const toggler = document.querySelector('.navbar-toggler');
        const sideMenuWrapper = document.querySelector('.side-menu-wrapper');
        const closeMenu = document.querySelector('.close-menu');
        const overlay = document.querySelector('.side-menu-overlay');

        if (!toggler || !sideMenuWrapper || !closeMenu || !overlay) {
            console.warn('Menu elements not found');
            return;
        }

        toggler.addEventListener('click', function () {
            console.log('Toggler clicked');
            sideMenuWrapper.classList.add('open');
        });

        closeMenu.addEventListener('click', function () {
            console.log('Close menu clicked');
            sideMenuWrapper.classList.remove('open');
        });

        overlay.addEventListener('click', function () {
            console.log('Overlay clicked');
            sideMenuWrapper.classList.remove('open');
        });

        console.log('Menu initialized successfully');
    },

    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */
    swiperSlider: function () {

        // Initialize products Swiper (if it exists in the template)
        const products = document.querySelector('#swiper-products');

        if (products && typeof Swiper !== 'undefined') {
            try {
                const productsSwiper = new Swiper('#swiper-products', {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    pagination: {
                        el: '.products-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.col-arrow:last-child .swiper-button-next',
                        prevEl: '.col-arrow:first-child .swiper-button-prev',
                    },
                    autoHeight: false,
                    speed: 500,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1200: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                    },
                });
                console.log('Products Swiper initialized successfully');
            } catch (error) {
                console.error('Error initializing Products Swiper:', error);
            }
        }

    },

    smoothScrollToTop: function () {
        const scrollToTopButton = document.getElementById('scrollToTop');

        if (!scrollToTopButton) return;

        scrollToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollToTopButton.classList.add('visible');
            } else {
                scrollToTopButton.classList.remove('visible');
            }
        });
    },

    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },

}

// Initialize theme when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    theme.init();
});
